// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"32":"vacation-finder","535":"congratulations-view"}[chunkId] + "." + {"32":"91f2a6a362a2e57d6ba8","535":"99b4f17632fd2ad2df84"}[chunkId] + ".css";
};